<div class="recommendations-table">
    <table class="cyber-table">
        <thead>
            <tr>
                <th>CyberAttack</th>
                <th>Recommendation</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let recommendation of recommendations">
                <td>{{ recommendation.cyberAttack }}</td>
                <td contenteditable="true" (blur)="askUpdateRecommendation($event, recommendation)">{{
                    recommendation.recommendation }}</td>
            </tr>
        </tbody>
    </table>

</div>